import React, { memo } from 'react';
import classNames from 'classnames';

import { IconButton } from '../../helpers/IconButton';

import style from './style.module.css';

const BIC = ({ tags, models, onClick, className }) => {
  const rows = [];

  if (models.size) {
    models.forEach(model => {
      if (model.get('checked')) {
        rows.push(
          <tr key={`${model.get('id')}${model.get('category')}`}>
            <td>
              <span>{model.get('category')}</span>
            </td>
          </tr>,
        );
      }
    });
  }

  if (tags.size) {
    tags.forEach(tag => {
      if (tag.get('checked')) {
        rows.push(
          <tr key={tag.get('id')}>
            <td>
              <span>{tag.get('category')}</span>
            </td>
          </tr>,
        );
      }
      tag.get('children').forEach(c => {
        if (c.get('checked')) {
          rows.push(
            <tr key={c.get('id')}>
              <td>
                <span>{c.get('category')}</span>
              </td>
            </tr>,
          );
        }
      });
    });
  }

  if (rows.length === 0) {
    rows.push(
      <tr key="norow">
        <td>No rows to display</td>
      </tr>,
    );
  }

  return (
    <div className={classNames(style.host, className)}>
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th className="plus-icon">
              <div>
                <span>
                  <IconButton
                    className="mr5"
                    icon="plus"
                    onClick={onClick}
                    size="sm"
                    title="Add industry tags"
                    variant="primary"
                  />
                  <span>Industry Tags</span>
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default memo(BIC);
